import { NgModule } from '@angular/core';
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from '@ngrx/effects';
import { RouterStoreModule } from "@ngrx/router-store";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { reducer } from './app-reducer';
import { APP_STATE_INIT } from './app-state';
import { UserEffect } from './user/index';

@NgModule({
  imports: [
    StoreModule.provideStore(reducer, APP_STATE_INIT),
    RouterStoreModule.connectRouter(),
    StoreDevtoolsModule.instrumentOnlyWithExtension(),
    EffectsModule.run(UserEffect),
  ],
  exports: [
    StoreModule,
    RouterStoreModule,
    StoreDevtoolsModule,
  ],
})
export class AppStoreModule {}



// WEBPACK FOOTER //
// ./src/app/store/app-store.module.ts